<template>
  <div id="app">
    <navigation>
      <router-view />
    </navigation>
    <!-- <img v-if="isShowCust" @touchstart="touchstart($event)" @touchmove="touchmove($event)" @touchend="touchend" ref="cust" id="cust" src="@/assets/images/common/cust.png" /> -->
  </div>
</template>

<script>
import mixin from '@/mixins/cust';
import { getUrlParam } from '@/assets/js/common'
import { updateChannel } from '@/api/index'
import { checkLogin2 } from '@/api/discover'
export default {
  name: "app",
  mixins: [mixin],
  created() {
    /**
     * m站初始化数据
     */
    window.isOtherApp = false
    this.isOneHight()
    this.isThirdEmb()

    /**
     * 更新渠道
     */
    let urlP = getUrlParam()
    let localValue = this.getLocalValue('MkeyCode')
    if (urlP.keyCode) {
      if (localValue && localValue == urlP.keyCode && this.localValueIsInTime('MkeyCode')) {
        // 在有效期内，不需要更新渠道
      } else {
        this.setLocal('MkeyCode', urlP.keyCode)
        // 更新渠道
        this.updateChannelM(urlP.keyCode, urlP.channelCode)
      }
    } else {
      if (localValue) {
        if (this.localValueIsInTime('MkeyCode')) {
          // 在有效期内，不需要更新渠道
        } else {
          // 更新渠道为默认渠道
          this.updateChannelM('', 3)
        }
      }
    }
    if (urlP.isMinCode) { //无默认值 1为将m站keycode传给小程序
      localStorage.setItem('enableMinCode', urlP.isMinCode)
    }
  },
  methods: {
    // 判断第三方app渠道(一嗨)
    isOneHight() {
      let channelCode = getUrlParam().channelCode || ''
      if (channelCode && channelCode == 1003) {
        localStorage.oneHigh = 1
      }
    },
    // 判断第三方内嵌
    isThirdEmb() {
      let thirdLogin = getUrlParam().thirdLogin || ''
      if (thirdLogin && thirdLogin == 1) {
        localStorage.thirdLogin = 1
      } else {
        localStorage.removeItem('thirdLogin')
      }
    },
    // 更新渠道
    updateChannelM(keyCode, channelCode) {
      // 用户登录的情况下 更新登陆渠道  否则不更新至保存keycode
      checkLogin2().then(res => {
        if (res.success) {
          updateChannel({
            d: JSON.stringify({
              activityCode: localStorage.activityCode || '',
              channelCode: channelCode || '',
              thirdKeyCode: keyCode || 0
            })
          }).then(res => { })
        }
      })
    },
    // SsetLocal
    setLocal(key, value) {
      if (key && value) {
        let endDate = Date.parse(new Date()) + 24 * 60 * 60 * 1000
        localStorage.setItem(key, value)
        localStorage.setItem(key + 'Expirse', endDate)
      }
    },
    getLocalValue(key) {
      let data = localStorage.getItem(key) || ''
      return data
    },
    // getLocal
    localValueIsInTime(key) {
      let data = localStorage.getItem(key)
      let expirse = localStorage.getItem(key + 'Expirse')
      if (data != null) {
        // 判断是否过期
        let curDate = Date.parse(new Date())
        if (expirse != null && curDate > expirse) {
          localStorage.removeItem(key)
          localStorage.removeItem(key + 'Expirse')
          return ''
        } else {
          return data;
        }
      }
    }
  },
  watch: {
  }
};
</script>

<style lang="less">
#app {
  background: #F8F8F8;
  position: relative;
  height: 100%;

  #cust {
    position: fixed;
    top: 50%;
    right: 0;
    z-index: 99;
    transform: translate(0, -50%);
    width: 50px;
    height: 50px;
  }
}

.van-dialog {
  /deep/ .van-dialog__content {
    .van-dialog__message {
      padding: 30px 25px;
      font-size: 14px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: justify;
      color: #333333;
      line-height: 18px;
    }
  }

  /deep/.van-dialog__footer {
    display: flex;
    justify-content: center;
    margin: 0 25px 20px;

    &::after {
      border: 0;
    }

    .van-button {
      width: 105px;
      flex: none;
      height: 35px;
      border-radius: 20px;
    }

    .van-dialog__cancel {
      border: 1px solid #FFAC00;
      background: #fff;
      color: #FFAC00;
      margin-right: 20px;

    }

    .van-dialog__confirm {
      background: #FFAC00;
      color: #fff;
      border: 0;

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue